import axios from 'axios';
import { UserProfile } from '../@posturinn/client-react';
import { IAccountService, VerificationId } from '../@posturinn/common-react/core';
import {
	CHANGE_PASSWORD_ERROR,
	CHANGE_PASSWORD_PENDING,
	CHANGE_PASSWORD_SUCCESS,
	CHECK_EMAIL_VERIFICATION_TOKEN_ERROR,
	CHECK_EMAIL_VERIFICATION_TOKEN_PENDING,
	CHECK_EMAIL_VERIFICATION_TOKEN_SUCCESS,
	CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR,
	CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING,
	CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS,
	REQUEST_EMAIL_VERIFICATION_ERROR,
	REQUEST_EMAIL_VERIFICATION_PENDING,
	REQUEST_EMAIL_VERIFICATION_SUCCESS,
	REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR,
	REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING,
	REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS,
} from '../constants/actions/accountActions';
import { MOBIZ_API_URL, MOBIZ_VERIFY_EMAIL } from '../constants/paths/api';
import store from '../store';
import { closeAllModals } from './modalActions';
import { updateUserProfileFulfilled } from './userProfileActions';

export const changePassword = (oldPassword: string, password: string, confirmPassword: string) => {
	return async function (dispatch) {
		const { injector } = store.getState().mobizReducer;
		const accountService: IAccountService = injector.get(IAccountService);
		dispatch({ type: CHANGE_PASSWORD_PENDING });
		accountService.changePassword({ oldPassword, password, confirmPassword }).subscribe({
			next: () => {
				dispatch({ type: CHANGE_PASSWORD_SUCCESS });
				dispatch(closeAllModals());
				document.body.style.overflow = 'unset';
			},
			error: error => {
				let err = '';
				try {
					// eslint-disable-next-line prefer-destructuring
					err = error.info.errors[0];
				} catch (e) {
					try {
						// eslint-disable-next-line prefer-destructuring
						err = error.info.password[0];
					} catch (er) {
						// Intentionally left blank: fallback not needed
					}
				}
				dispatch({ type: CHANGE_PASSWORD_ERROR, payload: err });
			},
		});
	};
};

export const requestEmailVerification = (email: string) => {
	return async function (dispatch) {
		const { injector } = store.getState().mobizReducer;
		const accountService: IAccountService = injector.get(IAccountService);
		dispatch({ type: REQUEST_EMAIL_VERIFICATION_PENDING });
		accountService.requestEmailVerification(email).subscribe({
			next: () => {
				dispatch({ type: REQUEST_EMAIL_VERIFICATION_SUCCESS });
			},
			error: error => {
				let err = '';
				try {
					err = error.info.details;
				} catch (e) {
					// Intentionally left blank: fallback not needed
				}
				dispatch({ type: REQUEST_EMAIL_VERIFICATION_ERROR, payload: err });
			},
		});
	};
};

export const requestPhoneNumberVerificationToken = (phoneNumber: string) => {
	return async function (dispatch) {
		const { injector } = store.getState().mobizReducer;
		const accountService: IAccountService = injector.get(IAccountService);
		dispatch({ type: REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING });
		accountService.requestPhoneNumberVerificationToken(phoneNumber).subscribe({
			next: (verificationId: VerificationId) => {
				dispatch({ type: REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS, payload: verificationId });
			},
			error: error => {
				let err = '';
				try {
					err = error.info.details;
				} catch (e) {
					// Intentionally left blank: fallback not needed
				}
				dispatch({ type: REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR, payload: err });
			},
		});
	};
};

export const checkPhoneNumberVerificationToken = (
	verificationId: VerificationId,
	token: string,
	userProfile: UserProfile
) => {
	return async function (dispatch) {
		const { injector } = store.getState().mobizReducer;
		const accountService: IAccountService = injector.get(IAccountService);
		userProfile.phoneNumberVerified = true;
		dispatch({ type: CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING });
		accountService.checkPhoneNumberVerificationToken(verificationId, token).subscribe({
			next: () => {
				dispatch({ type: CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS });
				dispatch(updateUserProfileFulfilled(userProfile));
				dispatch(closeAllModals());
				document.body.style.overflow = 'unset';
			},
			error: error => {
				let err = '';
				try {
					err = error.message;
				} catch (e) {
					// Intentionally left blank: fallback not needed
				}
				dispatch({ type: CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR, payload: err });
			},
		});
	};
};

export const checkEmailVerificationToken = (verificationId: string, token: string, userProfile: UserProfile) => {
	return async dispatch => {
		dispatch({ type: CHECK_EMAIL_VERIFICATION_TOKEN_PENDING });

		try {
			const query = `${MOBIZ_API_URL}${MOBIZ_VERIFY_EMAIL}${verificationId}?token=${token}`;
			await axios(query);
			userProfile.emailVerified = true;
			dispatch(updateUserProfileFulfilled(userProfile));
			dispatch(closeAllModals());
			dispatch({ type: CHECK_EMAIL_VERIFICATION_TOKEN_SUCCESS });
			document.body.style.overflow = 'unset';
		} catch (error) {
			let err = '';
			try {
				err = error?.response?.data?.details;
			} catch (e) {
				// Intentionally left blank: fallback not needed
			}
			if (!err) {
				err = 'Óvænt villa';
			}
			dispatch({ type: CHECK_EMAIL_VERIFICATION_TOKEN_ERROR, payload: err });
		}
	};
};

// export const resendVerificationEmail = (verificationId: VerificationId) => {
// 	return async function (dispatch) {
// 		const { injector } = store.getState().mobizReducer;
// 		const accountService: IAccountService = injector.get(IAccountService);
// 		dispatch({ type: RESEND_VERIFICATION_EMAIL_PENDING });
// 		accountService.resendVerificationEmail(verificationId).subscribe({
// 			next: () => {
// 				dispatch({ type: RESEND_VERIFICATION_EMAIL_SUCCESS });
// 			},
// 			error: error => {
// 				dispatch({ type: RESEND_VERIFICATION_EMAIL_ERROR, payload: error });
// 			},
// 		});
// 	};
// };
